export const checkPoints = [
  {
    type: "panorama",
    name: "全景视图1",
    id: "panorama1",
    position: [121.41591, 31.165537],
    minScale: 0,
    maxScale: 20000,
    focusDistance: 1000000,
  },
  {
    type: "passageway",
    name: "通道视图1",
    id: "passageway1",
    position: [121.41591, 31.165537],
    minScale: 15000,
    maxScale: 2000,
    focusDistance: 10000,
  },
  {
    type: "cross",
    name: "中兴大道—三环东路",
    id: "31300800001",
    position: [120.14524738, 30.87523023],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.14524738, 30.87523023, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "中兴大道—西山路",
    id: "31300800002",
    position: [120.15108168, 30.8752041],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15108168, 30.8752041, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "中兴大道—常溪南路",
    id: "31300800003",
    position: [120.15831828, 30.87517417],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15831828, 30.87517417, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道-乌山路",
    id: "33050200017",
    position: [120.1564605329828, 30.860704733853414],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.1564605329828, 30.860704733853414, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "中兴大道行人过街",
    id: "31300800004",
    position: [120.16594138, 30.87521214],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.16594138, 30.87521214, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "中兴大道—蜀山路",
    id: "31300800005",
    position: [120.17936826, 30.87464008],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.17936826, 30.87464008, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "中兴大道—区府路",
    id: "31300800006",
    position: [120.18547297, 30.8732588],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18547297, 30.8732588, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "中兴大道—戴山路",
    id: "31300800007",
    position: [120.19562244, 30.87077245],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.19562244, 30.87077245, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "中兴大道—南太湖大道",
    id: "31300800008",
    position: [120.20630836, 30.86893066],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.20630836, 30.86893066, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "谈家扇路—蜀山路",
    id: "31300800009",
    position: [120.15123457, 30.87129505],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15123457, 30.87129505, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "南塘漾路—西山路",
    id: "31300800010",
    position: [120.17880187, 30.86580913],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.17880187, 30.86580913, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "南塘漾路—区府路",
    id: "31300800011",
    position: [120.18549104, 30.86371761],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18549104, 30.86371761, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "南塘漾路—戴山路",
    id: "31300800012",
    position: [120.19492507, 30.86362612],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.19492507, 30.86362612, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "南塘漾路—升山路",
    id: "31300800013",
    position: [120.20057379, 30.86359966],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.20057379, 30.86359966, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "南塘漾路—南太湖大道",
    id: "31300800014",
    position: [120.20719886, 30.86360309],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.20719886, 30.86360309, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "吴兴大道—三环东路",
    id: "31300800015",
    position: [120.14494292, 30.86144357],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.14494292, 30.86144357, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "吴兴大道—蜀山路",
    id: "31300800016",
    position: [120.15107632, 30.86145264],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15107632, 30.86145264, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道—乌山路",
    id: "31300800017",
    position: [120.15643922, 30.86073902],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15643922, 30.86073902, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道—小山路",
    id: "31300800018",
    position: [120.16278069, 30.85681033],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.16278069, 30.85681033, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道—西山路",
    id: "31300800019",
    position: [120.17798424, 30.85555822],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.17798424, 30.85555822, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道—区府路",
    id: "31300800020",
    position: [120.18527985, 30.85745553],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18527985, 30.85745553, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道—戴山路",
    id: "31300800021",
    position: [120.19443154, 30.85736343],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.19443154, 30.85736343, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "吴兴大道—南太湖大道",
    id: "31300800022",
    position: [120.20729542, 30.85671872],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.20729542, 30.85671872, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "吴兴大道—义山路",
    id: "31300800023",
    position: [120.21654367, 30.85670038],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.21654367, 30.8567003, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道—纸坊路",
    id: "31300800024",
    position: [120.22525161, 30.85744896],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.22525161, 30.85744896, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "草荡漾路—三环东路",
    id: "31300800025",
    position: [120.1447228, 30.85334205],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.1447228, 30.85334205, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "草荡漾路—蜀山路",
    id: "31300800026",
    position: [120.15099049, 30.85320036],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15099049, 30.85320036],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "草荡漾路—乌山路",
    id: "31300800027",
    position: [120.15482363, 30.85291092],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15482363, 30.85291092, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "草荡漾路—小山路",
    id: "31300800028",
    position: [120.16230404, 30.85129376],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.16230404, 30.85129376, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "草荡漾路—区府路",
    id: "31300800029",
    position: [120.18461466, 30.84977398],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18461466, 30.84977398, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "草荡漾路—姚山路",
    id: "31300800030",
    position: [120.18916368, 30.84872393],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18916368, 30.84872393, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "草荡漾路—戴山路",
    id: "31300800031",
    position: [120.19363761, 30.84765545],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.19363761, 30.84765545, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "西湖漾路—姚山路",
    id: "31300800032",
    position: [120.18943191, 30.85259246],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18943191, 30.85259246, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "西湖漾路—戴山路",
    id: "31300800033",
    position: [120.1939702, 30.85181416],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.1939702, 30.85181416, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "西湖漾路—升山路",
    id: "31300800034",
    position: [120.20007491, 30.85166679],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.20007491, 30.85166679, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "叶堤漾路—蜀山路",
    id: "31300800035",
    position: [120.15108116, 30.85327719],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15108116, 30.85327719, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "叶堤漾路—乌山路",
    id: "31300800036",
    position: [120.15482562, 30.85291495],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15482562, 30.85291495, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "叶堤漾路—小山路",
    id: "31300800037",
    position: [120.16219183, 30.84737781],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.16219183, 30.84737781, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "叶堤漾路—区府路",
    id: "31300800038",
    position: [120.18414795, 30.84479077],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18414795, 30.84479077, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "叶堤漾路—姚山路",
    id: "31300800039",
    position: [120.18886328, 30.8436025],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18886328, 30.8436025, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "叶堤漾路—戴山路",
    id: "31300800040",
    position: [120.1932621, 30.8424004],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.1932621, 30.8424004, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "叶堤漾路—南太湖大道",
    id: "31300800041",
    position: [120.20733359, 30.84103816],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.20733359, 30.84103816, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "叶堤漾路—义山路",
    id: "31300800042",
    position: [120.21758324, 30.84197409],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.21758324, 30.84197409, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "G318—三环东路",
    id: "31300800043",
    position: [120.14446735, 30.84535266],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.14446735, 30.845352662, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "G318—区府路",
    id: "31300800044",
    position: [120.18367628, 30.83933574],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18367628, 30.83933574, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "G318—南太湖大道",
    id: "31300800045",
    position: [120.20737257, 30.83572397],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.20737257, 30.835723974, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "苕溪东路—二环东路",
    id: "31300800046",
    position: [120.12263183, 30.86361803],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.16284849344365, 30.856761136920213, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "苕溪东路-陆王路",
    id: "31300800047",
    position: [120.13028383, 30.86224237],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.13028383, 30.86224237, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "苕溪东路-大升路",
    id: "31300800048",
    position: [120.13618469, 30.86145264],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.13618469, 30.86145264, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "苕溪东路-东南湾路",
    id: "31300800049",
    position: [120.14524738, 30.87523023],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.14524738, 30.87523023, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "中横港路—三环东路",
    id: "31300800050",
    position: [120.1509583, 30.8812055],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.1509583, 30.8812055, 120],
      heading: 0,
      tilt: 90,
    },
    panelPositions: [],
  },
  {
    type: "cross",
    name: "中横港路—蜀山路",
    id: "31300800051",
    position: [120.1509583, 30.8812055],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.1509583, 30.8812055, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "中横港路—常溪南路",
    id: "31300800052",
    position: [120.15844278, 30.88287001],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.15844278, 30.88287001, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道-小山路",
    id: "33050200018",
    position: [120.16284849344365, 30.856761136920213],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.16284849344365, 30.856761136920213, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道-西山路",
    id: "33050200019",
    position: [120.17792895664414, 30.855588555979164],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.17792895664414, 30.855588555979164, 120],
      heading: 0,
      tilt: 90,
    },
  },
  {
    type: "cross",
    name: "吴兴大道-区府路",
    id: "33050200020",
    position: [120.18529542151492, 30.857459137547238],
    minScale: 600,
    maxScale: 0,
    camera: {
      position: [120.18529542151492, 30.857459137547238, 120],
      heading: 0,
      tilt: 90,
    },
  },
];
